import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CircularProgress from '@material-ui/core/CircularProgress';
import { BtnShape, BtnText } from '../InvDownload/InvDowload.styled';
import Chip from '@material-ui/core/Chip';
import InfoIcon from '@material-ui/icons/Info';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Box, Grid } from '@material-ui/core';
import { Trans } from 'react-i18next';
import { InfoNote } from '../UI';

export const UploadInventoryProductUpdate = ({ onClick }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid direction="column">
      <div>
        <BtnShape onClick={onClick}>
          <CloudUploadIcon />
          <BtnText>{t('Inventory.buttonUpload.productUpdate')}</BtnText>
        </BtnShape>
      </div>
      <Box mt={1}>
        <Chip
          icon={<InfoIcon />}
          label={t('Inventory.buttonMoreInfo')}
          color="primary"
          variant="outlined"
          size="small"
          onClick={handleClickOpen}
        />
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {t('Inventory.productUpdateUpload.dialogInfoTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('Inventory.productUpdateUpload.dialogInfoContent')}
          </DialogContentText>
          <Box mt={2}>
            <h4>{t('Inventory.productUpdateUpload.formatTitle')}</h4>
            <p>{t('Inventory.productUpdateUpload.formatDescription')}</p>
            <InfoNote variant="info">
              {t('Inventory.productUpdateUpload.noteFields')}
            </InfoNote>
            <ul>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnId"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnSku"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnName"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnPrice"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnDiscount"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnDescription"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnCategoryName"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnDiscountInitDate"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="Inventory.productUpdateUpload.columnDiscountEndDate"
                  components={{ strong: <strong /> }}
                />
              </li>
            </ul>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {t('Inventory.buttonOk') || 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

UploadInventoryProductUpdate.propTypes = {
  onClick: PropTypes.func,
};

export const UploadInventoryProductUpdating = () => {
  const { t } = useTranslation();
  return (
    <Grid direction="column">
      <BtnShape disabled>
        <CircularProgress color="secondary" size={20} thickness={7} />
        <BtnText>{t('Inventory.buttonUploading')}</BtnText>
      </BtnShape>
      <Box mt={1}>&nbsp;</Box>
    </Grid>
  );
};
